import React from 'react';
import { IconProps } from '../types';

interface CustomIconProps extends IconProps {
  viewBox?: string;
  role?: string;
  'aria-hidden'?: boolean;
}

export const SsfClose = React.memo<CustomIconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
    width,
    height,
    role = 'img',
    'aria-hidden': ariaHidden = false,
  }) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      className={className}
      onClick={onClick}
      role={role}
      aria-hidden={ariaHidden}
      style={{ cursor: onClick ? 'pointer' : 'inherit' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.17574 4.17574C4.41005 3.94142 4.78995 3.94142 5.02426 4.17574L12 11.1515L18.9757 4.17574C19.2101 3.94142 19.5899 3.94142 19.8243 4.17574C20.0586 4.41005 20.0586 4.78995 19.8243 5.02426L12.8485 12L19.8243 18.9757C20.0586 19.2101 20.0586 19.5899 19.8243 19.8243C19.5899 20.0586 19.2101 20.0586 18.9757 19.8243L12 12.8485L5.02426 19.8243C4.78995 20.0586 4.41005 20.0586 4.17574 19.8243C3.94142 19.5899 3.94142 19.2101 4.17574 18.9757L11.1515 12L4.17574 5.02426C3.94142 4.78995 3.94142 4.41005 4.17574 4.17574Z"
        fill="#111111"
      />
    </svg>
  ),
);

SsfClose.displayName = 'SsfClose';
